import { render, staticRenderFns } from "./casehistorydetails.vue?vue&type=template&id=b8231900&scoped=true"
import script from "./casehistorydetails.vue?vue&type=script&lang=js"
export * from "./casehistorydetails.vue?vue&type=script&lang=js"
import style0 from "./casehistorydetails.vue?vue&type=style&index=0&id=b8231900&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8231900",
  null
  
)

export default component.exports